<style lang="scss">
.p-marginer {
  background-size: 100% 100%;
  background-repeat: no-repeat;

  em {
    font-size: inherit;
  }
  ul {
    list-style: unset !important;
  }
  ol {
    list-style-type: decimal !important;
  }
}
.p-marginer {
  p {
    // margin-bottom: 10px;
  }
}
.p-marginer > ul,
.p-marginer > ol {
  padding-left: 15px;
}
.feed-content a {
  color: #2d8cf0 !important;
  text-decoration: underline !important;
}

.p-marginer > p > img {
  max-width: 100%;
}

.pdf-action-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 8px;
  .action-back {
    background: white;
  }
}

.action-back > img {
  margin-top: 0px !important;
  padding: 6px;
}

.action-back {
  border-style: solid;
  border-width: 1px;
  width: 36px;
  height: 36px;
  border-color: var(--link-color);
}

.ql-editor-full-width {
  img {
    width: 100%;
  }
}
</style>

<style scoped lang="scss">
.feed-item-title-wrapper {
  padding: 10px;
  text-align: center;
  span {
    font-weight: 600;
    font-size: 1.1em;
  }
}

.image-preview-container {
  object-fit: cover;
  overflow: hidden;
  text-align: center;
  background: #fff;
}
.image-preview-container > img {
  height: auto;
  width: 100%;
  margin: 0 auto;
}

.feed-single-page-template .ivu-avatar-large {
  width: 54px;
  height: 54px;
}

.multiline-ellipsis {
  display: block;
  display: -webkit-box;
  max-width: 400px;
  /* min-height: 25px; */
  line-height: 20px;
  /* margin: 0 auto; */
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.see-more-group {
  display: flex;
  align-items: center;
  justify-content: center;
  /* margin-right: 20px; */
  margin-top: 20px;
}
.color-normal {
  color: #616772;
  /* font-weight: bold; */
}
.color-unlike {
  color: #2d8cf0;
  font-weight: bold;
}
</style>
<style>
.action-like > img {
  margin-top: 7px;
  height: 15px;
  width: 15px;
}
.action-bookmark > img {
  margin-top: 8px;
  height: 15px;
  width: 10px;
}
.remove-footer > .ivu-modal-wrap > .ivu-modal {
  left: 50%;
  width: 130px !important;
}
.remove-footer
  > .ivu-modal-wrap
  > .ivu-modal
  > .ivu-modal-content
  > .ivu-modal-footer {
  display: none !important;
}
.action-margin-top {
  margin-top: 10px;
}
.feed-single-page-template .feed-header {
  /* display: none; */
  display: flex;
  align-items: center;
  padding: 10px 10px 8px;
  border-bottom: 1.2px solid #dddd  
}
</style>


<template>
  <app-layout class="feed-single-page-template" style="padding-bottom:100px">
    <!-- {{feedItem.careplan.type}} -->
    <div v-if="isPDFReader || !articleNotFound">
      <Row type="flex" justify="center">
        <Col :span="24" v-if="isPDFReader">
          <PDFViewer :src="pdfSrc"/>
          <div class="pdf-action-wrapper">
            <div @click="goBackHistory()" class="pointer">
              <Avatar class="action-back" :src="require('@/assets/back.png')"/>
            </div>
          </div>
        </Col>
        <Col :span="24" v-else-if="feedItem && 'id' in feedItem && !loadingFeed">
          <Card shadow :style="{borderRadius: '0'}" :padding="0">
            <!-- <span @click="onRefirectPoster(feedItem.poster)" style="padding:10px;display: flex; align-items: center">
              <Avatar
                shape="square"
                size="small"
                style="width: 50px; height: 50px;"
                :src="userDisplayImage(feedItem.poster.avatar)"
                v-if="feedItem.poster && feedItem_type=='user_post'||'document'"
                :style="{float:'left', marginRight: '10px'}"
              />
              <div style="display: flex; flex-direction: column;">
                <small style="color: #aeaeae">
                  Posted By
                </small>
                <b>
                  {{feedItem.poster.display_name}}
                </b>
              </div>
            </span> -->
            <!-- <div>
              <div>
                <img :src="feedItem.poster.avatar" class="" alt="">
                <h3>{{ feedItem.poster.display_name }} > {{ feedItem.careplan.title }}</h3>
              </div>
            </div> -->
            <div class="feed-header" v-if="!isActionMenu && !isModule && !isSubMenu && !isDiscover && !isResource && feedItem.careplan">
              <!-- <Dropdown placement="bottom-end" style="float:right; padding-right:10px;" v-if="$store.state.user.info.user_type !== 'guest'">
                  <img alt=" " v-if="feedItem.bookmarked" src="@/assets/icons8-bookmark-filled-50.png" style="height:12px;width:14px;margin-right:0px;">
                  <a style="padding:4px 10px; color: black;">
                    <Icon size="20" type="android-more-vertical"></Icon>
                  </a>
                  <DropdownMenu slot="list">
                      <DropdownItem>
                        <a @click="bookmarkItem(feedItem)" >{{ (feedItem.bookmarked) ? 'Unbookmark':'Bookmark' }}</a>
                      </DropdownItem>
                      <DropdownItem>
                        <a @click="showReport(feedItem.activity_id)">Report this post</a>
                      </DropdownItem>
                  </DropdownMenu>
              </Dropdown>-->
              <!-- <img alt=" " v-if="feedItem.bookmarked" src="@/assets/icons8-bookmark-filled-50.png" style="height:15px;width:15px;position:absolute;top:13px;right:35px;"> -->
              <!-- <Icon :id="'menuId' + feedItem.id" @click="showDoAction(feedItem.id)" size="20" type="android-more-vertical" style="position: absolute;top:10px;right:20px;"></Icon> -->
              <div
                 class="pointer"
                @click="avatarClick(feedItem)"
                :style="feedItem_data_type === 'info' ? 'cursor: default' : ''"
              >
                <Avatar
                  style="border-radius: 50%;"
                  size="large"
                  :src="userDisplayImage(feedItem.poster.avatar)"
                  v-if="feedItem.poster && !feedItem.poster.is_staff"
                  :style="{float:'left', marginRight: '10px'}"
                />
                <Avatar
                  shape="square"
                  size="large"
                  :src="posterPreviewImage(feedItem)"
                  v-else
                  :style="{float:'left', marginRight: '10px'}"
                />
              </div>
              <!-- <p style="padding-left:50px;margin-right: 35px;">
                <b class="multiline-ellipsis">{{convertSpecialChar(feedItem.title)}}</b>
                <small style="color:#aaa">
                  <timeago :since="feedItem.rrule_parsed_date"></timeago>
                  <b @click="viewResource(feedItem.careplan_id)">
                  &middot; {{feedItem.careplan.title}}</b>
                </small>
              </p>-->
              <div style="display: flex; flex-direction: column; width: 80%;" @click="toogleTitle()">
                
                <b class="truncate">
                  <span class="pointer" v-if="profileInfo.careplan_id == feedItem.careplan.id || profileInfo.private_careplan_id == feedItem.careplan.id" @click="avatarClick(feedItem)">
                    {{ feedItem.poster.display_name }}
                  </span>
                  <b v-else-if="feedItem.poster.is_staff" class="truncate pointer" @click="viewResource(feedItem)">
                    {{feedItem.careplan.title}}
                  </b>
                  <span v-else>
                    <span class="pointer" @click="avatarClick(feedItem)">
                      {{feedItem.poster.display_name}}
                    </span>
                    ►
                    <span class="pointer" @click="viewResource(feedItem)">
                      {{feedItem.careplan.title}}
                    </span>
                  </span>
                </b>
                <small>
                  <timeago :since="feedItem.rrule_parsed_date"></timeago>
                </small>
              </div>
            </div>
            <div v-if="feedItem.poster.is_staff" class="feed-item-title-wrapper">
              <span>
                {{ removeHTMLTags(feedItem.title) }}
              </span>
            </div>
            <div class="feed-content" style="margin-top:0px">
              <PDFViewer v-if="feedItem && feedItem.type == 'pdf'" :src="feedItem.data.pdf"/>
              <video-player
                :id="'PLAYER'+feedItem.id.split('-')[0]"
                v-if="(feedItem.type == 'video_object' || feedItem.data.attachment_type === 'video') && (feedItem.data.video || feedItem.data.url)"
                :poster="postPreviewImage(feedItem, 'large')"
                :src="feedItem.data.video || feedItem.data.url"
                @play="onPlayVideo"
                @pause="onPauseVideo"
                @mounted="addVideo"
              />
              <div v-if="(feedItem.data && isPodcastFile(feedItem))">
                <audio-player 
                  style="margin: 8px 0px; padding: 12px 15px"
                  v-if="(feedItem.type == 'podcast' || feedItem.type == 'podcast_object') && (feedItem.data && feedItem.data.podcast)"
                  :src="feedItem.data.podcast"/>
              </div>
              <div
                class="image-preview-container"
                v-if="showCoverPhoto(feedItem) && (feedItem.cover_photo && (feedItem.data.attachment_type !== 'slideshow' && feedItem.data.attachment_type !== 'document'))"
                style="width: 100%; margin-top: 10px;"
              >
                <div style="position:relative">
                  <video-player
                    :id="'PLAYER'+feedItem.id.split('-')[0]"
                    v-if="feedItem.data.attachment_type === 'video' && (feedItem.data.video || feedItem.data.url)"
                    :poster="postPreviewImage(feedItem, 'large')"
                    :src="feedItem.data.video || feedItem.data.url"
                    @play="onPlayVideo"
                    @pause="onPauseVideo"
                    @mounted="addVideo"
                  />
                  <div
                    v-else-if="feedItem.type!='menu'"
                    @click="showVuerSingle($event,'imgViewer')"
                  >
                    <progressive-img
                      v-if="feedItem.type != 'statement'"
                       v-show="feedItem.data && (!('is_rich_text' in feedItem.data) || !feedItem.data.is_rich_text)"
                      :src="postPreviewImage(feedItem, 'large')"
                      :placeholder="postPreviewImage(feedItem, 'medium')"
                      :blur="0"
                      width="100%"
                      alt="IMAGE"
                    />
                  </div>
                  <img
                    v-show="false"
                    ref="imgViewer"
                    :src="feedItem.cover_photo[0].original"
                    width="100%"
                    alt="IMAGE"
                  >
                  <!-- <Spin size="large" fix v-if="feedItem_type === 'attachment' && feedItem.data.attachment_type === 'video' && !isPlayerReady"></Spin> -->
                </div>
              </div>
              <!-- <div style="padding: 8px 10px 0" v-if="feedItem.is_shareable"> -->
              <div style="padding: 8px 10px 0;" v-if="feedItem.is_shareable">
                <SharePost :item="feedItem"></SharePost>
              </div>
              <div
                style="padding: 8px 10px 0; word-wrap:break-word; display: flex;flex-direction:column"
                :style="{padding: contentPadding}"
              >
                <!-- <BackTop style="bottom:0px !important;top:90px;"></BackTop> -->
                
                <div v-if="feedItem_type === 'trivia'">
                  <div v-if="feedItem.data.mode === 'true_or_false'">
                    <RadioGroup style="padding:10px 0">
                      <Radio label="true">
                        <span>True</span>
                      </Radio>
                      <Radio label="false">
                        <span>False</span>
                      </Radio>
                    </RadioGroup>
                  </div>
                  <div v-else-if="feedItem.data.mode === 'multiple'">
                    <Checkbox
                      v-for="(item,itemIndx) in feedItem.data.choices"
                      :key="itemIndx"
                      :label="item.text"
                    >{{item.text}}</Checkbox>
                  </div>
                  <div v-else-if="feedItem.data.mode === 'checklist'">
                    <Checkbox
                      v-for="(item,itemIndx) in feedItem.data.choices"
                      :key="itemIndx"
                      :label="item.text"
                    >{{item.text}}</Checkbox>
                  </div>
                  <div v-else-if="feedItem.data.mode === 'poll'">
                    <poll-component style="margin-top:15px" :poll-item="feedItem.data"/>
                  </div>
                </div>
                <div v-else-if="feedItem_type === 'attachment'">
                  <div
                    v-if="feedItem.data.attachment_type === 'slideshow' || feedItem.data.attachment_type === 'document' || feedItem.data.attachment_type === 'playlist'"
                  >
                    <div v-if="feedItem.data.attachment_type === 'slideshow' || feedItem.data.attachment_type === 'document'">
                      <!-- <slideshow-component
                        :slideshow-item="feedItem.data"
                        :cover-photo="postPreviewImage(feedItem, 'large')"
                        :slideshow-description="feedItem.data.text"
                      /> -->
                    <div @click="openVuer($event, 'slideshowViewer' + i)" v-for="(image, i) in feedItem.data.list" :key="i" style="display: flex; justify-content: center; align-items: center; margin: 5px 0;">
                       <progressive-img :src="getImage(image.photo_uri)" :alt="'image-'+i"/>
                       <img
                        v-show="false"
                        :ref="'slideshowViewer' + i"
                        :src="getImage(image.photo_uri)"
                        width="100%">   
                      </div>
                    </div>
                  </div>
                  <!-- <div v-else class="p-marginer" v-html="feedItem.data.text"></div> -->
                </div>
                <div v-else-if="feedItem_type === 'recipe'">
                  <p>
                    <b style="width:150px;display:inline-block">Calories</b>
                    : {{feedItem.data.calories}}
                  </p>
                  <p>
                    <b style="width:150px;display:inline-block">Meal Type</b>
                    : {{feedItem.data.meal_type}}
                  </p>
                  <p>
                    <b style="width:150px;display:inline-block">No. of Servings</b>
                    : {{feedItem.data.serving}}
                  </p>
                  <p style="margin-top:10px">
                    <b>Description:</b>
                  </p>
                  <div class="p-marginer" v-html="feedItem.data.description"></div>
                  <p style="margin-top:10px">
                    <b>Instructions:</b>
                  </p>
                  <div class="p-marginer" v-html="feedItem.data.instruction"></div>
                </div>
                <div v-else-if="feedItem_type === 'reveal'">
                  <p>
                    Question:
                    <br>
                    <b>{{feedItem.data.question}}</b>
                  </p>
                  <p style="margin-top:10px">
                    Answer:
                    <br>
                    {{feedItem.data.answer}}
                  </p>
                </div>
                <div style="padding:12px 15px;">
                  <div v-if="feedItem.type === 'check_in'" style="margin-right: 6px; width: fit-content; height: fit-content;">
                    <i class="fa fa-map-marker-alt" />
                  </div>
                  <div style="display: flex; flex-direction: column;">
                    <div :style="{'background-color': feedItem.data ? feedItem.data.backgroundColor : '', 'background-image': feedItem.data && feedItem.data.backgroundImage ? 'url('+ feedItem.data.backgroundImage +')' : ''}" class="p-marginer" v-html="contentDisplay(feedItem)"/>
                    <div v-if="feedItem.type == 'check_in'">
                      <small style="color: #aaaaaa;">
                        {{feedItem.data.text}}
                      </small>
                    </div>
                  </div>
                </div>
                <div align="center" v-if="profileInfo.user_type === 'guest'">
                  <div
                    style="margin:15px 0 20px; text-align: center"
                    v-on:click="showLoginModal('signup')"
                  >
                    <Button type="primary">
                      <img :src="tmLogo" width="25" style="vertical-align:middle">
                      Join Us at
                      <b>Sharpen Warrior</b>
                    </Button>
                  </div>
                </div>
              </div>
              <!-- <router-link :to="'/resources/' + feedItem.careplan.id" tag="div" class="see-more-group" v-if="feedItem.day != -1">
                <small style="margin-right: 10px; color: #2d8cf0;">See more ...</small>
                <Avatar :src="feedItem.careplan.thumbnail_photo[0].medium" size="small" />
              </router-link>-->
              <!-- <BackTop style="margin-bottom:100px;"></BackTop> -->
            </div>
            <div class="feed-actions" :style="{padding: '0 10px 0px'}">
              <Row>
                <Col span="24">
                  <div
                    class="floating-image"
                    v-if="feedItem_careplan_type === 'artwork'"
                    align="center"
                  >
                    <Button @click="copyToClipboard(feedItem)" type="text">
                      <i style="font-size:20px;vertical-align: middle" class="far fa-copy"></i>&nbsp;Copy to Clipboard
                    </Button>
                  </div>
                </Col>
                <Col span="24" style="margin-bottom: 10px;">
                  <div class="floating-image" v-if="feedItem.data.attachment_type == 'link'">
                    <a
                      href="javascript:void();"
                      style="margin:10px 0; display: flex; font-size: 0.9em"
                      @click="viewExternally(feedItem.data.url)"
                    >
                      Source:&nbsp;
                      <span style="line-height: 28px;font-size: 13px;word-break: break-word;">{{feedItem.data.url}}</span>
                    </a>
                  </div>
                </Col>
                <Col span="24" v-if="false">
                  <router-link tag="p" :to="'/feed/' + feedItem.id + '/comments'">
                    <i class="far fa-comment"></i>&nbsp;
                    <b>Comments {{ (feedItem.activity_count > 0) ? feedItem.activity_count : ''}}</b>
                  </router-link>
                </Col>
              </Row>
              <div style="display:flex;justify-content: center;display:none">
                <router-link
                  :to="'/resources/' + feedItem.careplan.id"
                  tag="div"
                  class="see-more-group"
                  v-if="feedItem.careplan && feedItem.day != -1 && feedItem.careplan && feedItem.careplan.id != groupID.donate"
                >
                  <!-- <small style="margin-right: 10px; color: #2d8cf0;">See more ...</small> -->
                  <Avatar :src="feedItem.careplan.thumbnail_photo[0].medium" size="small"/>
                </router-link>
              </div>
            </div>
            <Row type="flex" justify="center" align="top">
              <img
                alt=" "
                src="@/assets/end-comment.png"
                width="80px"
                height="40px"
                style="margin-top:-5px"
              >
            </Row>
            <Row type="flex" justify="center" align="top">
              <div style="display: flex; align-items: center; padding: 10px;">
                <div
                    v-if="isSystemPlan != 'system' && feedItem.careplan && !feedItem.poster.is_staff && feedItem.careplan.type != 'private_journal' && feedItem.careplan.type != 'journal'"
                    style="margin-right: 11px;"
                    class="pointer"
                    @click="goToResource(feedItem.careplan.id, feedItem)">
                  <Avatar
                    shape="square"
                    size="large"
                    :src="feedItem.careplan.thumbnail_photo[0].small"
                    style="width: 42px; height: 42px;"
                  />
                </div>
                <div @click="goBackHistory()" class="pointer">
                  <Avatar class="action-back" :src="require('@/assets/back.png')"/>
                </div>
              </div>
            </Row>
            <div v-if="!isActionMenu && !isResource || (isModule && isDocuments)">
              <div
                v-if="!(showCoverPhoto(feedItem) && (feedItem.cover_photo && feedItem.data.attachment_type !== 'slideshow')) && (feedItem_data_type !== 'info')"
              >
                <ButtonsComponent
                  @likeBtn="doAction(0,feedItem)"
                  @showCommentMenu="doAction(1,feedItem)"
                  @share="doAction(2,feedItem)"
                  @bookmark="doAction(3,feedItem)"
                  @report="doAction(4,feedItem)"
                  @delete="confirmDelete(feedItem.careplan.id,feedItem.id)"
                  @edit="editItem(feedItem)"
                  :showLike="youveLikeIt()"
                  :likeCount="activityLikesCount"
                  :commentCount="commentCount"
                  :isBookmarked="feedItem.bookmarked"
                  :showShare="isShareableCapable() && feedItem.is_shareable"
                  :isAdmin="checkAdmin"
                  :isDocuments="isDocuments"
                />
              </div>
              <div v-else class="action-margin-top">
                <ButtonsComponent
                  @likeBtn="doAction(0,feedItem)"
                  @showCommentMenu="doAction(1,feedItem)"
                  @share="doAction(2,feedItem)"
                  @bookmark="doAction(3,feedItem)"
                  @report="doAction(4,feedItem)"
                  @delete="confirmDelete(feedItem.careplan.id,feedItem.id)"
                  @edit="editItem(feedItem)"
                  :showLike="youveLikeIt()"
                  :likeCount="activityLikesCount"
                  :commentCount="commentCount"
                  :isBookmarked="feedItem.bookmarked"
                  :showShare="isShareableCapable() && feedItem.is_shareable"
                  :isAdmin="checkAdmin"
                  :isDocuments="isDocuments" />
              </div>
            </div>
          </Card>
          <Row style="margin-top:10px;">
            <!-- <Comments v-if="feedItem.day != -1" v-show="true" :feedItem="feedItem" :commentFocus="scroll"></Comments> -->
            <Comments
              :hasLike="activityLikesCount > 0"
              :showLike="false"
              v-show="true"
              :feedItem="feedItem"
              :commentFocus="true"
            ></Comments>
          </Row>
        </Col>
        <ReportComment :itemtype="'comment'" :commentid="commentid"></ReportComment>
        <ReportActivity :itemtype="'activity'" :activityid="activityid"></ReportActivity>
      </Row>

      <!-- activity dot3 -->
      <Modal v-model="activityOptions1" :closable="false" :mask-closable="false">
        <p slot="header" style="text-align:center">
          <Icon type="ios-information-circle"></Icon>
          <span>Actions</span>
          <img
            alt=" "
            @click="activityOptions=false"
            style="height:25px; width:25px;position:absolute;top:0;right:0;margin:10px 10px 0 0;"
            src="@/assets/close.png"
          >
        </p>
        <div class="flex-container direction-col">
          <div
            v-show="isNotGuest && youveLikeIt() && !isLiking"
            class="direction-row center"
            style="padding:5px 0 5px 0;"
            @click="doAction(1,feedItem)"
          >
            <Avatar
              class="action-like"
              :src="require('@/assets/thumbs-up-filled.png')"
              style="background:#333;vertical-align:middle;"
            ></Avatar>&nbsp;&nbsp;&nbsp;
            <p v-if="isLiking">Unliking...</p>
            <p v-else>Unlike</p>
          </div>
          <div
            v-show="isNotGuest || !youveLikeIt() && !isLiking"
            class="direction-row center"
            style="padding:5px 0 5px 0;"
            @click="doAction(1,feedItem)"
          >
            <Avatar
              class="action-like"
              :src="require('@/assets/thumbs-up.png')"
              style="background:#333;vertical-align:middle;"
            ></Avatar>&nbsp;&nbsp;&nbsp;
            <p v-if="isLiking">Liking...</p>
            <p v-else>Like</p>
          </div>

          <div
            class="direction-row center"
            style="padding:5px 0 5px 0;"
            @click="doAction(2,feedItem)"
          >
            <Avatar
              class="action-like"
              icon="ios-chatboxes"
              style="background:#333;vertical-align:middle;"
            ></Avatar>&nbsp;&nbsp;&nbsp; Comment
          </div>
          <div
            v-if="isShareableCapable() && feedItem.is_shareable"
            class="direction-row center"
            style="padding:5px 0 5px 0;"
            @click="doAction(3,feedItem)"
          >
            <Avatar
              class="action-like"
              icon="android-share-alt"
              style="background:#333;vertical-align:middle;"
            ></Avatar>&nbsp;&nbsp;&nbsp; Share
          </div>
          <div
            v-show="!feedItem.bookmarked"
            class="direction-row center"
            style="padding:5px 0 5px 0;"
            @click="doAction(4,feedItem)"
          >
            <Avatar
              class="action-bookmark"
              :src="require('@/assets/bookmark-white.png')"
              style="background:#333;vertical-align:middle;"
            ></Avatar>&nbsp;&nbsp;&nbsp; Bookmark
          </div>
          <div
            v-show="feedItem.bookmarked"
            class="direction-row center"
            style="padding:5px 0 5px 0;"
            @click="doAction(4,feedItem)"
          >
            <Avatar
              class="action-bookmark"
              :src="require('@/assets/bookmark-fill.png')"
              style="background:#333;vertical-align:middle;"
            ></Avatar>&nbsp;&nbsp;&nbsp; Unbookmark
          </div>
          <div
            class="direction-row center"
            style="padding:5px 0 5px 0;"
            @click="doAction(5,feedItem)"
          >
            <Avatar
              class="action"
              :src="require('@/assets/bullhorn.png')"
              style="background:#333;vertical-align:middle;"
            ></Avatar>&nbsp;&nbsp;&nbsp; Report this post
          </div>
        </div>
        <div slot="footer"></div>
      </Modal>

      <ReportModalComponent :type="reportType" v-if="reportType" @closeModal="reportType = null"></ReportModalComponent>

      <Modal
        class="remove-footer"
        v-model="activityOptions"
        :closable="false"
        :mask-closable="true"
        width="100"
      >
        <div
          class="flex-container direction-col"
          v-for="(action, iaction) in doActionList"
          :key="iaction"
        >
          <div
            v-show="action.id==1"
            class="direction-row center"
            style="padding:5px 0 5px 0;"
            @click="doAction(iaction,feedItem)"
          >
            <label class="color-unlike" v-if="youveLikeIt()">Unlike</label>
            <label class="color-normal" v-else-if="!youveLikeIt()">{{ action.name }}</label>
          </div>
          <div
            v-if="isMobile()"
            v-show="action.id==3"
            class="direction-row center"
            style="padding:5px 0 5px 0;"
            @click="doAction(iaction,feedItem)"
          >{{ action.name}}</div>
          <div
            v-show="action.id==4"
            class="direction-row center"
            style="padding:5px 0 5px 0;"
            @click="doAction(iaction,feedItem)"
          >
            <label class="color-unlike" v-if="feedItem.bookmarked">Unbookmark</label>
            <label class="color-normal" v-else-if="!feedItem.bookmarked">{{ action.name }}</label>
          </div>
          <div
            v-show="action.id==5"
            class="direction-row center"
            style="padding:5px 0 5px 0;"
            @click="doAction(iaction,feedItem)"
          >
            <label class="color-normal">{{ action.name }}</label>
          </div>
          <div
            v-show="action.id!=1 && action.id!=3 && action.id!=4 && action.id!=5"
            class="direction-row center"
            style="padding:5px 0 5px 0;"
            @click="doAction(iaction,feedItem)"
          >{{ action.name }}</div>
        </div>
        <div slot="footer"></div>
      </Modal>

      <ModalHolder
        m-top="30"
        :title="''"
        :is-show="showLikeModal"
        :mWidth="'90%'"
        :mHeight="'75vh'"
        :closable="false"
        @on-close="showLikeModal=false"
        class="post-update-modal"
      >
        <template slot="mheader"></template>
        <template slot="mcontent0" v-if="activityLikes">
          <LikeComponent :users="activityLikes"></LikeComponent>
        </template>
      </ModalHolder>

      <Modal v-model="showSinglePreview" @on-cancel="showSinglePreview = false">
        <div slot="header"><br></div>
        <div style="display:flex; justify-content: center;">
          <Spin v-if="isSinglePreviewLoading"/>
          <CourseComponent
            style="margin: 0px -10px; max-width: -webkit-fill-available; width: 100%;"
            :section="'group'"
            v-if="!isSinglePreviewLoading && singleFeedItem && isGuid(singlePreviewItemId)"
            :pSingleFeedItem="singleFeedItem"
          />
          <iframe v-else-if="singlePreviewItemId && !isGuid(singlePreviewItemId)" style="height: 60vh;margin: 0;width: 100%;border: none;" :src="singlePreviewItemId"></iframe>
        </div>
        <div slot="footer">
          <p></p>
        </div>
      </Modal>
    </div>
    <div v-else style="display: flex; height: 80vh; align-items: center;">
      <h3 style="text-align: center; margin: 25px; width: 100%;">Article not found</h3>
    </div>
  </app-layout>
</template>

<script>
const mime = require("mime");
import Utils from "@/utils.js";
import { getIdFromURL } from "vue-youtube-embed";
import { Message } from "iview";
import VuerMixin from "@/helpers/vuerMixin";
import SharePost from "@/components/SharePostComponent";
import SlideshowComponent from "@/components/SlideshowComponent";
import PollComponent from "@/components/PollComponent3";
import Comments from "@/components/CommentsComponent";
import ReportComment from "@/components/ReportComponent";
import ReportActivity from "@/components/ReportComponent";
import VueCookie from "vue-cookie";

import bookmark from "@/assets/bookmark-2.svg";
import bookmarked from "@/assets/bookmark-1.svg";
import applogo from "@/assets/logo.png";
import ReportModalComponent from "@/components/ReportModalComponent";
import ButtonsComponent from "@/components/ButtonsActionComponent";

import ModalHolder from "@/components/ModalHolderComponent";
import LikeComponent from "@/components/LikeComponent";
import CourseComponent from "@/components/CourseComponent";
import VideoPlayerComponent from "@/components/VideoPlayerComponent";

import Vue from "vue";
import { mapGetters } from "vuex"
import _ from "lodash"
import PDFViewer from "@/components/pdf/PDFViewer"

export default {
  name: "FeedSingleComponent",
  components: {
    SharePost,
    SlideshowComponent,
    PollComponent,
    Comments,
    ReportComment,
    ReportActivity,
    ReportModalComponent,
    ButtonsComponent,
    ModalHolder,
    LikeComponent,
    CourseComponent,
    PDFViewer
  },
  computed: {
    ...mapGetters("user", ["isBroadcast"]),
    isPDFReader() {
      return this.$route.params.activityID === "pdf"
    },
    pdfSrc() {
      return this.$route.query.src
    },
    isSystemPlan() {
      return _.get(this.feedItem, "careplan.access");
    },
    isSubMenu() {
      let isSub = _.get(this.feedItem, "careplan.type", null)
      return (isSub && isSub == "sub_menu");
    },
    isDiscover() {
      let isDisc = _.get(this.feedItem, "careplan.type", null)
      return (isDisc && isDisc == "discover");
    },
    isResource() {
      let isResource = _.get(this.feedItem, "careplan.type", null)
      return (isResource && isResource == "resource");
    },
    isModule() {
      let isModule = _.get(this.feedItem, "careplan.type", null)
      return (isModule && isModule == "module");
    },
    isActionMenu(){
      let isActionMenu = _.get(this.feedItem, "careplan.type", null)
      return (isActionMenu && isActionMenu == "do_action_menu")
    },
    feedItem_careplan_type: function() {
      if (
        this.feedItem.careplan &&
        this.feedItem.careplan.hasOwnProperty("type")
      )
        return this.feedItem.careplan.type;
      return "";
    },
    feedItem_type: function() {
      if (this.feedItem.careplan && this.feedItem.hasOwnProperty("type"))
        return this.feedItem.type;
      return "";
    },
    feedItem_data_type: function() {
      if (this.feedItem.careplan && this.feedItem.data.hasOwnProperty("type"))
        return this.feedItem.data.type;
      return "";
    },
    activityLikesCount: function() {
      // return Utils.numFormatterToK(1000);
      if ( this.$store.state.feed && this.$store.state.feed.activityLikes )
        return Utils.numFormatterToK(
          this.$store.state.feed.activityLikes.data.likes.length
        );
      return 0
    },
    currentUserId: {
      get() {
        return this.$store.state.user.info.id;
      }
    },
    youveLikeIt: function() {
      return function() {
        var likeFound = _.find(this.activityLikes, ["id", this.currentUserId]);
        return likeFound != undefined;
      };
    },
    isNotGuest: function() {
      return this.$store.state.user.info.user_type !== "guest";
    },
    activityLikes: function() {
      return this.$store.state.feed.activityLikes.data.likes;
    },
    commentCount: function() {
      return this.$store.state.feed.feedSingleItemActivities.activities
        ? Utils.numFormatterToK(
            this.$store.state.feed.feedSingleItemActivities.activities.length
          )
        : 0;
    },
    activityid: function() {
      return this.$store.state.user.reportThisId;
    },
    commentid: function() {
      return this.$store.state.user.reportThisId;
    },
    scroll: {
      get() {
        return this.$route.query.scroll === "true";
      }
    },
    checkAdmin: {
      get() {
        return (
          this.$route.query.isAdmin == true ||
          this.$route.query.isAdmin == "true" ||
          this.showDeletebtn
        );
      }
    },
    isDocuments: {
      get() {
        return (
          this.$route.query.isDocuments == true ||
          this.$route.query.isDocuments == "true"
        );
      }
    },
    userDocuments: {
      get() {
        return this.$store.state.user.documents.data.careplan_item;
      }
    },
    profileInfo: {
      get() {
        return this.$store.state.user.info;
      }
    },
    feedItem: {
      get() {
        return this.$store.state.feed.singleFeedView;
      }
    },
    section() {
      return this.feedItem
        ? this.feedItem.careplan.type == "journal" ||
          this.feedItem.careplan.type == "private_journal"
          ? "journal"
          : "group"
        : "group";
    },
    contentPadding: {
      get() {
        return this.feedItem.data.attachment_type === "slideshow"
          ? "0"
          : "8px 10px 0";
      }
    },
    loadingFeed: {
      get() {
        return this.$store.state.feed.isSingleFeedView;
      }
    }
  },
  data() {
    return {
      collapseTitle: false,
      doActionList: [
        { id: 1, name: "Like" },
        { id: 2, name: "Show comment" },
        { id: 3, name: "Share" },
        { id: 4, name: "Bookmark" },
        { id: 5, name: "Report this post" }
      ],
      isLiking: false,
      showComment: false,
      bookmarkIcon: {
        on: bookmarked,
        off: bookmark
      },
      tmLogo: applogo,
      selection: {
        value: true
      },
      isPlayerReady: false,
      vuerOptions: {
        navbar: false,
        title: false,
        toolbar: false,
        scalable: false,
        fullscreen: false,
        keyboard: false
      },
      activityOptions: false,
      activityOptions1: false,
      reportType: null,
      groupID: Cons[0].GROUP_ID,
      showLikeModal: false,
      showDeletebtn: false,
      showEditbtn: false,
      showSinglePreview: false,
      isSinglePreviewLoading: false,
      singlePreviewItemId: null,
      singleFeedItem: null,
      singleFeedPromise: null,
      articleNotFound: false,
      videoPlayers: [],
      currentlyPlaying: null,
      courseIdleDuration: {
        startTime:'',
        endTime:'',
        timeDuration:''
      }
    };
  },
  watch: {
    $route: function(n, o) {
      if (n) this.loadItem();
    }
  },
  beforeDestroy(){
    let newDate = new Date();
    newDate = newDate.getTime();
    
    this.courseIdleDuration.endTime = newDate ////milliseconds
    this.courseIdleDuration.timeDuration = Math.floor((this.courseIdleDuration.endTime - this.courseIdleDuration.startTime)/1000)
    console.log('this.courseIdleDuration',this.courseIdleDuration);
    // do something here Course Time!!!

    if(this.currentlyPlaying){
      this.currentlyPlaying = {
        ...this.currentlyPlaying, 
        ...{src:this.currentlyPlaying.src, pauseTime: newDate, timeDuration: Math.floor((newDate - this.currentlyPlaying.playTime)/1000)
      }
    }
      console.log('this.currentlyPlaying',this.currentlyPlaying);
      // do something here Video Time!!!!
      this.$store.dispatch("points/setUserActionPoints", {
        action: "watch_video",
        video_link: this.currentlyPlaying.src,
        duration: this.currentlyPlaying.timeDuration,
        element_id: this.$route.params.activityID
      }, {root: 1})
      this.currentlyPlaying = null;
    }
  },
  mounted() {
    this.eventEmitter();
    this.loadItem();
    if (!this.checkAdmin) {
      this.isLoadingFeedItem = true;
      this.$store
        .dispatch("resource/getSingleResource", {
          id: this.feedItem.careplan_id || this.feedItem.id
        })
        .then(res => {
          this.isLoadingFeedItem = false;
          this.showDeletebtn =
            !this.checkIfCreator(res) || this.isUserAdmin(res);
        })
        .catch(err => {
          this.isLoadingFeedItem = false;
        });
    }

    // this.$nextTick(function() {
      setTimeout(() => {
        this.initPage()
      }, 1500);
    // })
    let newDate = new Date();
    newDate = newDate.getTime();
    this.courseIdleDuration.startTime = newDate ////milliseconds
  },
  mixins: [VuerMixin],
  methods: {
    mountPdfLinks() {
      setTimeout(() => {
        let thisComponent = this
        var pdfLinks = thisComponent.$el.querySelectorAll('.-ql-pdf-link')
        for (let pdfLink of pdfLinks) {
          pdfLink.addEventListener("click", (e) => {
            e.preventDefault();
            thisComponent.openPdf(pdfLink.href)
          });
        }
      }, 10)
    },
    openPdf(pdfUrl) {
      this.$router.push(`/feed/pdf?src=${pdfUrl}`)
    },
    getImage(uri) {
      return `${process.env.VUE_APP_BASE_IMAGE_URL}large${uri}`
    },
    removeHTMLTags(data) {
      if (data) return data.replace(/<\/?[^>]+(>|$)/g, "");
    },
    avatarClick(v) {
      if ( v.type === "user_post" ) {
        this.$router.push(`/${process.env.VUE_APP_DEV_ECOSYSTEM}/profile/${v.posted_by}?tab=me`)        
        return false;
      }

      if (v.poster.is_staff){
        this.viewResource(v)
      } else {
        if ( this.currentUserId === v.poster.id ) {
          this.$router.push('/profile/' + this.currentUserId)
          return false;
        }
        if (this.isBroadcast) {
          Message.warning("Unable to display user profile");
        }
        else {
          if (v.poster.is_public == 1)
            this.$router.push('/profile/' + v.poster.id)
          else
            Message.warning("Profile is not public");
        }
      }
    },
    onRefirectPoster(p) {
      this.$router.push(`/${process.env.VUE_APP_DEV_ECOSYSTEM}/profile/${p.id}?tab=me`)
    },
    initPage() {
      if (this.isPDFReader) return
      this.mountActivityRedirectLinks();
      this.mountZoomableImages();
      this.mountVideoLoaders();
      this.mountVideoPlayers();
      this.mountPdfLinks();
    },
    isGuid(str) {
      if (str[0] === "{") {
        str = str.substring(1, str.length - 1);
      }
      // var regexGuid = /^(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}$/gi;
      // var regexGuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
      var regexGuid = /^(\{{0,1}([0-9a-fA-F]){8}-([0-9a-fA-F]){4}-([0-9a-fA-F]){4}-([0-9a-fA-F]){4}-([0-9a-fA-F]){12}\}{0,1})$/g
      return regexGuid.test(str);
    },
    async loadSingleFeedItem() {
      this.isSinglePreviewLoading = true;
      try {
        let res = await this.$store.dispatch(
          "feed/getSingleItem",
          this.singlePreviewItemId
        );
        this.singleFeedItem = res.data;
      } catch (e) {
        console.log(e);
      } finally {
        this.isSinglePreviewLoading = false;
      }

      // this.singleFeedPromise = this.$store
      //   .dispatch('feed/getSingleItem', this.singlePreviewItemId)
      //   .then(res => {
      //     this.isSinglePreviewLoading = false
      //     res.data = this.singleFeedItem
      //   })
      //   .catch(err => {
      //     this.isSinglePreviewLoading = false
      //   })
    },
    isYoutubeVideo(item) {
      if (item.data.hasOwnProperty("video_ibj_id") && item.data.video_ibj_id)
        return true;
      return item.data.hasOwnProperty("video")
        ? Utils.validateYouTubeUrl(item.data.video)
        : item.data.hasOwnProperty("url") && item.data.url
        ? Utils.validateYouTubeUrl(item.data.url)
        : false;
    },
    toogleTitle: function() {
      this.collapseTitle = !this.collapseTitle;
      var element = document.getElementById("collapseTitleId");
      if (this.collapseTitle) element.classList.remove("multiline-ellipsis");
      else element.classList.add("multiline-ellipsis");
    },
    eventEmitter: function() {
      BroadcastEvent.$on("closeLikeModal", () => {
        this.showLikeModal = false;
      });
    },
    copyToClipboard(item) {
      if (this.feedItem && this.feedItem.cover_photo) {
        navigator.clipboard
          .writeText(this.feedItem.cover_photo[0].original)
          .then(() => {
            Message.info("Image copied to clipboard");
          })
          .catch(err => {
            Message.error("Could not copy text: ", err);
          });
      }
    },
    showDoAction(id) {
      this.activityOptions = true;
    },
    isShareableCapable() {
      return navigator.share ? true : false;
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
    share(act) {
      let desc = "";
      console.log("share...", act.type);
      switch (act.type) {
        case "user_post":
          desc = act.data.text;
          break;
        case "attachment":
          desc = act.data.text;
          break;
        case "trivia":
          desc = act.data.text;
          break;
        case "reveal":
          desc = act.data.question;
          break;
        default:
          desc = act.data.tip.replace(/(<([^>]+)>)/gi, "");
          break;
      }

      navigator
        .share({
          title: act.title,
          text: "",
          url: act.data.page_url // `${process.env.VUE_APP_SITE}/${process.env.VUE_APP_DEV_ECOSYSTEM}/feed/${act.id}`
        })
        .then(() => {
          this.$notice.info("Shared Successfully");
        })
        .catch(error => {
          this.$notice.error("Please try again later.");
        });

        this.$store.dispatch('statistics/postStats', {
          stat_type: 'activity_share',
          stat_id: act.id
        })
    },
    showCoverPhoto(feedItem) {
      return !(["poll"].indexOf(feedItem.data.mode) > -1);
    },
    doAction(i, feedItem) {
      if (
        this.profileInfo.user_type === "guest" &&
        (i == 0 || i == 2 || i == 3 || i == 4)
      ) {
        this.$store.commit("hitCheckpoint");
        return false;
      }

      if (i == 0) {
        // like/unlike
        this.$store.dispatch('statistics/postStats', {stat_type: 'activity_action', stat_id: feedItem.id, link_tag: 'Like Activity'});
        BroadcastEvent.$emit("onLike", this.youveLikeIt() ? false : true);
      } else if (i == 1) {
        // show comment
        this.$store.dispatch('statistics/postStats', {stat_type: 'activity_action', stat_id: feedItem.id, link_tag: 'View Activity Comments'});
        BroadcastEvent.$emit("onToggleComment");
      } else if (i == 2) {
        // Share
        // BroadcastEvent.$emit('onSharing');
        this.$store.dispatch('statistics/postStats', {stat_type: 'activity_action', stat_id: feedItem.id, link_tag: 'Share Activity'});
        this.share(feedItem);
      } else if (i == 3) {
        // Bookmark
        this.$store.dispatch('statistics/postStats', {stat_type: 'activity_action', stat_id: feedItem.id, link_tag: 'Bookmarked Activity'});
        this.bookmarkItem(feedItem);
      } else if (i == 4) {
        // Report this post
        // this.showReport(feedItem.activity_id);
        this.$store.dispatch('statistics/postStats', {stat_type: 'activity_action', stat_id: feedItem.id, link_tag: 'Reporting Activity'});
        this.showReport(feedItem.id);
      } else if (i == 5) {
        // Show Like
        this.$store.dispatch('statistics/postStats', {stat_type: 'activity_action', stat_id: feedItem.id, link_tag: 'View Activity Likes'});
        this.showLikeModal = true;
      }
      this.activityOptions = false;
    },
    // scrollBelow() {
    //   window.scrollTo(0, document.body.scrollHeight);
    // },
    showReport: function(activityid) {
      // this.activityid=activityid;
      this.$store.commit("user/setReportThisId", activityid);
      this.$store.commit("user/setShowStepsActivity", true);
    },

    onSelectMenu(n) {
      switch (n.n) {
        case "bookmark":
          this.bookmarkItem(n.feedItem);
          break;
        case "report":
          break;
      }
    },
    onYtReady(player) {
      // player.playVideo();
      return (this.isPlayerReady = player ? true : false);
    },
    getVideoId(url) {
      if (url.url) {
        return this.$youtube.getIdFromURL(url.url);
      } else if (url.video) {
        return this.$youtube.getIdFromURL(url.video);
      }
    },
    scrollBelow() {
      console.log("scrollBelow...", this.scroll);
      if (this.scroll) {
        window.scrollTo(0, document.body.scrollHeight);
      }
    },
    convertSpecialChar(mString) {
      if (mString) return mString.replace(/&#039;/g, "'");
    },
    viewExternally(url) {
      window.open(url, "_blank");
    },
    loadItem() {
      if (this.isPDFReader) return 
      let activityId = this.$route.params.activityID;

      //clear previously loaded feed item when id is not the same
      if (this.feedItem && this.feedItem.id && this.feedItem.id !== activityId)
        this.$store.commit('feed/setSingleFeed', {}, {root: 1})

      this.$store.dispatch("feed/loadFeed", activityId).then(
        res => {
          this.$store.dispatch("feed/activityLikes");
          if (this.$route.query.show_comment) {
            BroadcastEvent.$emit("onToggleComment");
          }
          setTimeout(() => {
            this.initPage();
          }, 1500);
        },
        error => {
          if (activityId)
            this.articleNotFound = error.response.status == 404;
        }
      );
      // Promise.all([
      //   this.$store.dispatch('feed/loadFeed', this.$route.params.activityID),
      //   this.$store.dispatch('feed/activityLikes', this.$route.params.activityID)
      // ])
      //   .then((values) => {
      //     // console.log('loadItem...', values);
      //    })
      //   .catch((error) => {
      //     // console.log('error...', error);
      //   });
    },
    openVuer(e,ref){
      this.showVuerSingle(e,ref);
      //do something Image
      let engageCourse = JSON.parse(VueCookie.get(`${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}ENGAGE_COURSE`));
      this.$store.dispatch("points/setUserActionPoints", {
        action: "view_image",
        user_story_id: engageCourse.userStory,
        track_id: engageCourse.course,
        module_id: engageCourse.article,
        category: engageCourse.category,
        element_id: this.$route.params.activityID
      }, { root: 1 });
    },
    mountActivityRedirectLinks() {
      var thisComponent = this;
      var anchors = thisComponent.$el.querySelectorAll(
        ".p-marginer > p > a"
      );

      for (let anchor of anchors) {
        if (
          this.isGuid(anchor.getAttribute("href")) &&
          anchor.classList.contains("action_link-goto")
        ) {
          anchor.addEventListener("click", e => {
            e.preventDefault();
            if (anchor.classList.contains('link_type-post_id'))
              this.$router.push("/feed/" + anchor.getAttribute('href'))
            else if (anchor.classList.contains('link_type-module_id'))
              this.$router.push("/module/" + anchor.getAttribute('href'))
            else if (anchor.classList.contains('link_type-element_id'))
              this.$router.push("/feed/" + anchor.getAttribute('href'))
          });
        } else if (
          this.isGuid(anchor.getAttribute("href")) &&
          anchor.classList.contains('action_link-popup')
        ) {
          anchor.addEventListener("click", e => {
            e.preventDefault();
            this.showSinglePreview = true;
            this.singlePreviewItemId = anchor.getAttribute("href");
            this.loadSingleFeedItem();
          });
        }
        else if (!this.isGuid(anchor.getAttribute('href')) && anchor.classList.contains('action_link-popup')) {
          anchor.addEventListener('click', (e)=> {
            e.preventDefault()
            this.showSinglePreview = true
            this.singlePreviewItemId = anchor.getAttribute('href')
          })
        }
      }
    },
    mountZoomableImages() {
      var thisComponent = this;
      var zoomableParent = thisComponent.$el.querySelectorAll(
        ".ql-editor-full-width > img"
      );
      for (let element of zoomableParent) {
        let img = element;
        img.onclick = function(event) {
          let src = img.currentSrc;
          img = new Image();
          img.src = src.replace("/large/", "/original/");
          thisComponent.showVuerSingleElement(event, img);
          //do something Image
          let engageCourse = JSON.parse(VueCookie.get(`${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}ENGAGE_COURSE`));
          thisComponent.$store.dispatch("points/setUserActionPoints", {
            action: "view_image",
            user_story_id: engageCourse.userStory,
            track_id: engageCourse.course,
            module_id: engageCourse.article,
            category: engageCourse.category,
            element_id: this.$route.params.activityID
          }, { root: 1 });
        };
      }
    },
    mountVideoLoaders() {
      let videosWithImg = this.$el.querySelectorAll('.ql-editor-video > img')
      if (!videosWithImg) return

      for (var i = 0; i < videosWithImg.length; i++) {
        let videoImg = videosWithImg[i]

        videoImg.parentElement.parentElement.classList.add("p-relative")

        let loadingNode = document.createElement('div')
        loadingNode.classList.add("video-loader")
        let loader = document.createElement("i")
        loadingNode.appendChild(loader)
        loader.classList.add("fa")
        loader.classList.add("fa-spin")
        loader.classList.add("fa-spinner")
        videoImg.parentElement.appendChild(loadingNode) 
      }
    },
    mountVideoPlayers(){
      let thisComponent = this
      var videosWithImg = thisComponent.$el.querySelectorAll('.ql-editor-video > img')

      if (!videosWithImg) return

      for (var i = 0; i < videosWithImg.length; i++) {
        var videoImg = videosWithImg[i]
        var videoSrc = ''
        var poster = ''

        var videoSrc = videoImg.parentElement.classList[2].replace('src-', '')
        for (let index = 3; index < videoImg.parentElement.classList.length; index++) {
          if(!videoImg.parentElement.classList[index].startsWith("img-")){
              videoSrc += `+${videoImg.parentElement.classList[index]}`;
          }else{
              poster = videoImg.parentElement.classList[index].replace('img-', '')
              break;
            }
        }

        var isYoutubeVideo = Utils.validateYouTubeUrl(videoSrc)

        var VideoPlayerClass = Vue.extend(VideoPlayerComponent)
        var instance = new VideoPlayerClass({
          propsData: {
            id: 'COURSE-QUILL-PLAYER-' + i,
            src: videoSrc,
            poster: poster,
            disabled: this.isEditMode
          }
        })

        instance.$on('mounted', (e) => {
          this.addVideo(e)
        })

        instance.$on('pause', (e,src) =>{
          let newDate = new Date();
          newDate = newDate.getTime();
          if(this.currentlyPlaying && src == this.currentlyPlaying.src && e == this.currentlyPlaying.videoplayer){
            this.currentlyPlaying = {
              ...this.currentlyPlaying, 
              ...{src, pauseTime: newDate, timeDuration: Math.floor((newDate - this.currentlyPlaying.playTime)/1000)
            }
          }
            console.log('this.currentlyPlaying',this.currentlyPlaying);
            //do something here Video Time!!!!
            this.$store.dispatch("points/setUserActionPoints", {
              action: "watch_video",
              video_link: this.currentlyPlaying.src,
              duration: this.currentlyPlaying.timeDuration,
              element_id: this.$route.params.activityID
            }, {root: 1})
            this.currentlyPlaying = null;
          }
        })

        instance.$on('play', (e,src) => {
          let newDate = new Date();
          newDate = newDate.getTime();
          if(this.currentlyPlaying){
            this.currentlyPlaying = {
              ...this.currentlyPlaying, 
              ...{src, pauseTime: newDate, timeDuration: Math.floor((newDate - this.currentlyPlaying.playTime)/1000)
            }
          }
            console.log('this.currentlyPlaying2',this.currentlyPlaying);
            this.$store.dispatch('statistics/postStats', {stat_type: 'activity_action', stat_id: this.$route.params.activityID, link_tag: 'Play Youtube Video Activity'});
            this.$store.dispatch("points/setUserActionPoints", {
              action: "watch_video",
              video_link: this.currentlyPlaying.src,
              duration: this.currentlyPlaying.timeDuration,
              element_id: this.$route.params.activityID
            }, {root: 1})
            this.currentlyPlaying = null;
          }
          this.currentlyPlaying = {videoplayer:e,src,playTime:newDate}
          this.pauseVideoExcept(e)
        })

        instance.$mount()

        videoImg.parentElement.appendChild(instance.$el)

        // remove dummy video loaders
        let loadingNode = videoImg.parentElement.children[1]
        loadingNode.remove()
        
        videoImg.remove()
      }
    },
    onPlayVideo(v,src){
      let newDate = new Date();
      newDate = newDate.getTime();
      if(this.currentlyPlaying){
        this.currentlyPlaying = {
          ...this.currentlyPlaying, 
          ...{src, pauseTime: newDate, timeDuration: Math.floor((newDate - this.currentlyPlaying.playTime)/1000)
        }
      }
        console.log('this.currentlyPlaying2',this.currentlyPlaying);
        this.$store.dispatch('statistics/postStats', {stat_type: 'activity_action', stat_id: this.$route.params.activityID, link_tag: 'Play Video Activity'});
        this.$store.dispatch("points/setUserActionPoints", {
          action: "watch_video",
          video_link: this.currentlyPlaying.src,
          duration: this.currentlyPlaying.timeDuration,
          element_id: this.$route.params.activityID
        }, {root: 1})
        this.currentlyPlaying = null;
      }
      this.currentlyPlaying = {videoplayer:v,src,playTime:newDate}
      this.pauseVideoExcept(v);
    },
    onPauseVideo(v,src){
      let newDate = new Date();
      newDate = newDate.getTime();
      if(this.currentlyPlaying && src == this.currentlyPlaying.src && v == this.currentlyPlaying.videoplayer){
        this.currentlyPlaying = {
          ...this.currentlyPlaying, 
          ...{src, pauseTime: newDate, timeDuration: Math.floor((newDate - this.currentlyPlaying.playTime)/1000)
        }
      }
      // do something here Video Time!!!!
      this.$store.dispatch("points/setUserActionPoints", {
        action: "watch_video",
        video_link: this.currentlyPlaying.src,
        duration: this.currentlyPlaying.timeDuration,
        element_id: this.$route.params.activityID
      }, {root: 1})
      console.log('this.currentlyPlaying',this.currentlyPlaying);
      this.currentlyPlaying = null;
      }
    },
    pauseVideoExcept(video){
      this.videoPlayers.forEach(videoPlayer => {
        if (videoPlayer !== video){
          videoPlayer.pause()
        }
      })
    },
    addVideo(video){
      this.videoPlayers.push(video)
    },
    // mountVideoPlayers() {
    //   let thisComponent = this;
    //   var videosWithImg = thisComponent.$el.querySelectorAll(
    //     ".ql-editor-video > img"
    //   );

    //   if (!videosWithImg) return;

    //   for (var i = 0; i < videosWithImg.length; i++) {
    //     console.log("video player " + i, videosWithImg[i].parentElement);

    //     var videoImg = videosWithImg[i];
    //     var videoSrc = videoImg.parentElement.classList[2].replace("src-", "");
    //     var poster = videoImg.parentElement.classList[3]
    //       ? videoImg.parentElement.classList[3].replace("img-", "")
    //       : "";
    //     var isYoutubeVideo = Utils.validateYouTubeUrl(videoSrc);

    //     var VideoPlayerClass = Vue.extend(VideoPlayerComponent);
    //     var instance = new VideoPlayerClass({
    //       propsData: {
    //         id: "COURSE-QUILL-PLAYER-" + i,
    //         src: videoSrc,
    //         poster: poster,
    //         disabled: this.isEditMode
    //       }
    //     });

    //     instance.$mount();

    //     videoImg.parentElement.appendChild(instance.$el);
    //     videoImg.remove();
    //   }
    // },
    viewResource(item) {
      event.stopPropagation()
      if (this.isPublic) return false;

      if ( item.type === "user_post" ) {
        this.$store.dispatch('statistics/postStats', {stat_type: 'link', stat_id: item.posted_by, link_tag: 'View poster profile'});
        this.$router.push(`/${process.env.VUE_APP_DEV_ECOSYSTEM}/profile/${item.posted_by}?tab=me`)        
        return false;
      }

      if ( item.careplan.type === "organization" ) {
        if (this.$route.path.split('/')[2] === 'organization') 
          return false;

        this.$store.dispatch('statistics/postStats', {stat_type: 'link', stat_id: item.careplan_id, link_tag: 'View organization profile'});
        this.$router.push(`/${process.env.VUE_APP_DEV_ECOSYSTEM}/organization/${item.careplan_id}?title=${item.title}`)        
        return false;
      }

      var id = item.careplan.id;
      if (item.type == "event_info" && item.data && item.data.group_id) {
        id = item.data.group_id;
      }
      if (this.section == "journal" && this.section == "group") {
        console.log("test");
      } else {
        if (item.type == "event_info") {
          this.$router.push({
            path: "/resources/" + id,
            query: { type: "event" }
          });
        } else {
          this.$store.dispatch('statistics/postStats', {stat_type: 'link', stat_id: id, link_tag: 'View resource'});
          this.$router.push({ path: "/resources/" + id });
        }
      }
    },
    bookmarkItem(item) {
      if (this.profileInfo.user_type !== "guest") {
        this.$store.dispatch("feed/bookmarkItem", { item }).then(
          res => {
            if (!item.bookmarked) {
              item.bookmark_id = res.id;
              item.bookmarked = 1;
            } else {
              delete item.bookmark_id;
              item.bookmarked = 0;
            }
          },
          err => {}
        );
      } else {
        this.$store.commit("hitCheckpoint");
      }
    },
    confirmDelete(careplanId, itemId) {
      this.$Message({
        closable: true,
        title: { content: "Delete Post" },
        icon: "ios-trash",
        message: { content: "Are you sure you want to delete this post?" },
        buttons: [
          {
            label: "Yes",
            type: "error",
            hideAfter: true,
            action: () => {
              this.$store.dispatch('statistics/postStats', {stat_type: 'activity_action', stat_id: itemId, link_tag: 'Delete Item'});
              this.deleteItem(careplanId, itemId)
            }
          },
          {
            label: "Cancel",
            type: "primary",
            hideAfter: true,
            action: () => {}
          }
        ]
      });
    },
    deleteItem(careplanId, itemId) {
      this.$store.commit('base/setLoadingPage', true)
      if (this.isDocuments) {
        this.$store.dispatch("user/deleteItem", itemId).then(r => {
          this.$store.commit('base/setLoadingPage', false)
          this.$Message({
            closable: true,
            // durationInSec:3,
            title: { content: "Success" },
            icon: "alert",
            message: { content: "Successfully Deleted" },
            buttons: [
              {
                label: "Ok",
                type: "primary",
                hideAfter: true,
                action: () => {
                  for (let x = 0; x < this.userDocuments.length; x++) {
                    if (this.userDocuments[x].id == itemId) {
                      this.$store.dispatch('statistics/postStats', {stat_type: 'activity_action', stat_id: itemId, link_tag: 'Delete Item'});
                      this.userDocuments.splice(x, 1);
                      break;
                    }
                  }
                  this.goBackHistory();
                }
              }
            ]
          });
        }),
          err => {};
      } else {
        this.$store
          .dispatch("feed/deleteItem", {
            careplanId: careplanId,
            itemId: itemId
          })
          .then(
            res => {
              this.$store.commit('base/setLoadingPage', false)
              this.$Message({
                closable: true,
                // durationInSec:3,
                title: { content: "Success" },
                icon: "alert",
                message: { content: "Successfully Deleted" },
                buttons: [
                  {
                    label: "Ok",
                    type: "primary",
                    hideAfter: true,
                    action: () => {
                      this.$store.dispatch('statistics/postStats', {stat_type: 'activity_action', stat_id: itemId, link_tag: 'Delete Item'});
                      this.goBackHistory()
                    }
                  }
                ]
              });
            },
            err => {}
          )
      }
    },
    editItem(v) {
      this.$store.commit("user/setUpdatedItem", v);
      this.openUpdateDocumentModal();
    },
    openUpdateDocumentModal() {
      this.$store.commit("menu/setPostDocumentModal", true);
    },
    goToResource(id, item){
      if ( item.careplan.type === "organization" ) {
        if (this.$route.path.split('/')[2] === 'organization') 
          return false;
        this.$router.push(`/${process.env.VUE_APP_DEV_ECOSYSTEM}/organization/${item.careplan_id}?title=${item.title}`)        
        return false;
      }

      this.$router.push({ path: "/resources/" + id });
    },
    goBackHistory() {
      this.$router.go(-1);
    },
    contentDisplay(act) {
      switch (act.type) {
        case "check_in":
          if (act.data) return act.title;
          break;
        case "user_post":
          if (act.data) return act.data.text;
          break;
        case "document":
          if (act.data) return act.data.notes;
          break;
        case "passport_expiration":
          return "Passport Expiration";
          break;
        case "contract_expiration":
          return "Contract Expiration";
          break;
        case "attachment":
          if (act.data) {
            switch (act.data.attachment_type) {
              case "video":
                let txt = act.data.text || act.data.preview_summary;
                if (act.data.text || act.data.preview_summary) {
                  return txt;
                }
                // return act.data.text || act.data.preview_summary;
                break;
              case "link":
                // if (act.data.text || act.data.preview_summary) {
                //   return "";
                // }
                return act.data.text || act.data.preview_summary;
                break;
              case "playlist":
                if (act.data.text) {
                  return "";
                }
                // return act.data.text || act.data.preview_summary;
                break;
              case "slideshow":
                // if (act.data.text) {
                //   return "";
                // }
                return "<div style='text-align:center'>" + act.data.text
                  ? act.data.text
                  : act.data.preview_summary
                  ? act.data.preview_summary
                  : "" + "</div>";
                break;
              case "image":
                // return "";
                return act.data.text || act.data.preview_summary;
                break;
              case "additional_documents":
                if (act.data.tip) {
                  return act.data.tip;
                }
                // return act.data.text || act.data.preview_summary;
                break;
              default:
                if (act.data.text) return act.data.text;
                else if (act.data.tip) return act.data.tip;
                break;
            }
          }
          break;
        case "trivia":
          if (act.data && act.data.question)
            return "<b>" + act.data.question + "</b>";
          break;
        case "reveal":
          if (act.data && act.data.question) return "";
          break;
        case "recipe":
          if (act.data && act.data.description) return "";
          break;
        case "video":
          if (act.data && act.data.text) {
            return act.data.text;
          }
          break;
        case 'pdf':
          if (act.data && act.data.text) { return act.data.text }
          break
        default:
          if (act.data) {
            if (act.data.tip) return Utils.getLinkAddress(act.data.tip);
            else if (act.data.description)
              return Utils.getLinkAddress(act.data.description);
            else if (act.data.text) return Utils.getLinkAddress(act.data.text);
          }
          break;
      }
      return "";
    },
    posterPreviewImage(item) {
      if (this.section == "journal") {
        return item.poster.avatar;
      }else if (item.carelan && item.careplan.type == "menu") {
        return item.cover_photo[0].small;
      } else if (item.careplan) {
        return item.careplan.thumbnail_photo[0]["small"];
      }
      else {
        return item.cover_photo[0].small
      }
    },
    postPreviewImage(act, size) {
      return Utils.getDisplayImage("activity", act, size);
    },
    userDisplayImage(user) {
      return Utils.getDisplayImage("user", user, "small");
    },
    showLoginModal(type) {
      if (VueCookie.get("os_type") === "ios" && !VueCookie.get('ios_app_version') ) {
        window.webkit.messageHandlers.onNativeCalled.postMessage({
          name: "authRegister",
          params: {}
        });
        return false;
      }

      this.reportType = type;
      if (type == "signin" || type == "signup")
        this.$router.push(`/${this.$route.params.brandSlug}/login?type=${type}`);
      // this.$store.commit('menu/setShowWizardModalComponent', true)
    },
    isUserAdmin(data) {
      if (data && data.permission) {
        if ("permission" in data.permission) {
          if (
            data.permission.permission == 511 ||
            data.permission.permission == 503 ||
            data.permission.permission == 0
          )
            return true;
        }
      } else {
        return false;
      }
    },
    checkIfCreator(data) {
      return !(data.submitted_by == this.profileInfo.id);
    },
    isPodcastFile(item){
      return item.type === 'podcast_object'
        || item.type === 'podcast'
        || (item.type == 'attachment' && item.data.attachment_type == 'podcast')
    }
  }
};
</script>
